import React, { Fragment } from 'react'
import propTypes from 'prop-types'
import sccssIcon from '../../../images/new-error-icon.svg'
import Button from '../Button'

const SupplyErrorModal = ({
  size,
  center,
  msg,
  buttonText,
  t,
  handleClose,
  className,
  details,
  detailsErrorMessage
}) => (
  <Fragment>
    <div id='supply-content-error-modal' className={`custom-modal ${size} ${className} custom-error-modal center`}>
      <img src={sccssIcon} />
      <h4 className='text-danger'>Ops! </h4>
      <span className={`${center && ' text-center'} msg-error`}>{msg}</span>
      {details && (
        <>
          <span className='please-msg'>
            Por favor, tente novamente ou abra um chamado, indicando o motivo, no Service Now.
          </span>
          <span
            className={`no-margin-top error-modal-details${
              center && ' text-center'
            }`}
          >
          </span>
        </>
      )}

      {(details || detailsErrorMessage) && (
        <span
          className={`no-margin-top error-modal-details${
            center && ' text-center'
          }`}
        >
          <span style={{ fontWeight: 600 }} className='no-margin details-msg'>
            Motivo: 
          </span>
          <i className='details-msg'>{details || detailsErrorMessage}</i>
        </span>
      )}

      <Button
        className='btn btn-primary w-100 supply-error-modal-btn'
        text={buttonText || t('stock.adjustment.parameters.try-again')}
        onClick={() => handleClose()}
      />
    </div>
    <div className='bg' onClick={() => handleClose()} />
  </Fragment>
)

SupplyErrorModal.propTypes = {
  size: propTypes.string,
  handleClose: propTypes.func,
  msg: propTypes.string,
  t: propTypes.func,
  center: propTypes.bool,
  buttonText: propTypes.string,
  details: propTypes.string,
  detailsErrorMessage: propTypes.string,
  className: propTypes.string,
}

export default SupplyErrorModal
